import { PRODUCT_MULTICURRENCY_EXPERIMENTAL_FLAG } from '@/consts/flags';
import { isLocalCurrency } from '@/utils/isLocalCurrency';

/**
 * Quem enxerga moeda estrangeira (seletor de moeda, OXXO/SPEI, filtros por moeda). Única fonte
 * no front para "este produtor é internacional" — os componentes chamam isto, não a lista.
 *
 * Lê `user.multicurrencyEnabled` antes de `experimental_features` porque o `/user/` fica 1h em
 * cache no backend e a lista congela junto: o produtor que sai do piloto perde os métodos
 * internacionais na hora, mas continuaria vendo o seletor e recebendo `400 Métodos de pagamento
 * inválidos` ao salvar. O campo é recalculado pós-cache, como `nfseEnabled` (CKTPC-1272).
 *
 * A queda para a lista só existe para backend que ainda não manda o campo; sai quando ele estiver
 * em produção.
 */
export const hasMultiCurrency = (user) => {
  if (typeof user?.multicurrencyEnabled === 'boolean') return user.multicurrencyEnabled;
  return (
    Array.isArray(user?.experimental_features) &&
    user.experimental_features.includes(PRODUCT_MULTICURRENCY_EXPERIMENTAL_FLAG)
  );
};

/**
 * Selo de moeda de um registro (produto, coprodução, afiliação). É exibição de dado, e não
 * capacidade (CKTPC-1731): quem vende em dólar continua vendo o selo em tudo, e quem não vende
 * passa a vê-lo quando o registro não é em real. Sem isso, o coprodutor e o afiliado de produto
 * USD, e quem criou produto USD antes de o internacional desligar, perdiam a moeda do próprio
 * dado.
 *
 * O valor não passa por aqui: sai sempre na moeda do registro. Passe o código já resolvido
 * (`getProductCurrency(...).code`) para o selo e o valor nunca discordarem.
 */
export const shouldShowRecordCurrency = (user, currency) =>
  hasMultiCurrency(user) || !isLocalCurrency(currency);
